import Session from "supertokens-auth-react/recipe/session";
import SuperTokens, { SuperTokensWrapper } from "supertokens-auth-react";
import App from "./App.tsx";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/themeProvider";
import "@/index.css";
import "@/sentry.ts";

export const queryClient = new QueryClient();

// Supertokens initialization
SuperTokens.init({
  appInfo: {
    appName: "Payment",
    apiDomain: `${window.location.protocol}//${window.location.host}`,
    apiGatewayPath: "/api",
    websiteDomain: `${window.location.protocol}//${window.location.host}`,
    apiBasePath: "/auth",
    websiteBasePath: "/auth",
  },
  recipeList: [
    Session.init({
      tokenTransferMethod: "header", // Because we use different domains for frontend and backend
    }),
  ],
});

hydrateRoot(
  document.getElementById("root")!,
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-center" duration={10000} />
      <ThemeProvider>
        <SuperTokensWrapper>
          <App />
        </SuperTokensWrapper>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
